import api from "./Api";

class GarconService {
  GetGarcon(payload) {
    return api.get("/v1/Garcon/" + payload).then((response) => response.data);
  }

  PostGarcon(payload) {
    return api.post("/v1/Garcon/", payload).then((response) => response.data);
  }

  PutGarcon(payload) {
    return api.put("/v1/Garcon/", payload).then((response) => response.data);
  }

  DeleteGarcon(payload) {
    return api
      .delete("/v1/Garcon/" + payload)
      .then((response) => response.data);
  }

  GetGarconOData(payload) {
    return api.get("/OData/Garcon" + payload).then((response) => response.data);
  }

  ValidarSenha(payload) {
    return api
      .post("/v1/Garcon/ValidarSenha", payload)
      .then((response) => response.data);
  }
}

export default new GarconService();
